export default __webpack_public_path__ + "static/media/editor-italic-btn-icon.0992ab65.svg";